export const ENVIRONMENTS = {
  PRODUCTION: 'production',
  STAGE: 'stage',
};
